
export enum HolyShrineType {
  ImamHussain = 'imam-hussain',
  HazratMassomeh = 'hazrat-massomeh'
}